import { combineReducers } from "redux";
import login from "../db/reducer/login";
import register from "../db/reducer/register";
import authDetails from "../db/reducer/otpValidation";
import loginAnotherWay from "../db/reducer/loginAnotherWay";
import forgotPassword from "../db/reducer/forgotPassword";
import resetPassword from "../db/reducer/resetPassword";
import resetPasswordRequestReducer, { ResetPasswordRequestAction } from "../db/reducer/resetPasswordRequest";
import profileInformation from "../db/reducer/ProfileInformation";
import userSetup from "../db/reducer/userSetup";
import accountSetup from "../db/reducer/accountSetup";
import { OtpAction } from "../db/reducer/otpValidation";
import { RegisterAction } from "../db/reducer/register";
import { LoginAnotherWayAction } from "../db/reducer/loginAnotherWay";
import { ForgotPasswordAction } from "../db/reducer/forgotPassword";
import { ResetPasswordAction } from "../db/reducer/resetPassword";

export const appReducer = combineReducers({
  login,
  register,
  authDetails,
  loginAnotherWay,
  forgotPassword,
  resetPassword,
  resetPasswordRequest: resetPasswordRequestReducer,
  profileInformation,
  userSetup,
  accountSetup,
});

export type RootState = ReturnType<typeof appReducer>;

/** Dispatched when landing on login page to reset entire app state to initial values */
export const ROOT_RESET = "ROOT_RESET" as const;

const rootReducer = (
  state: RootState | undefined,
  action:
    | RegisterAction
    | OtpAction
    | LoginAnotherWayAction
    | ForgotPasswordAction
    | ResetPasswordAction
    | ResetPasswordRequestAction
    | { type: typeof ROOT_RESET }
): RootState => {
  if (action.type === ROOT_RESET) {
    return appReducer(undefined, action);
  }

  // Safety check: Filter out any unknown keys that might have been persisted
  // This prevents "Unexpected key" warnings from combineReducers
  if (state) {
    const allowedKeys = [
      "login",
      "register",
      "authDetails",
      "loginAnotherWay",
      "forgotPassword",
      "resetPassword",
      "resetPasswordRequest",
      "profileInformation",
      "userSetup",
      "accountSetup",
    ];
    
    const hasUnknownKeys = Object.keys(state).some(key => !allowedKeys.includes(key));
    
    if (hasUnknownKeys) {
      const filteredState: any = {};
      allowedKeys.forEach((key) => {
        if (state[key as keyof RootState] !== undefined) {
          filteredState[key] = state[key as keyof RootState];
        }
      });
      
      console.warn("🟡 rootReducer: Filtered out unknown keys from state", {
        originalKeys: Object.keys(state),
        filteredKeys: Object.keys(filteredState),
        removedKeys: Object.keys(state).filter(key => !allowedKeys.includes(key)),
      });
      
      return appReducer(filteredState as RootState, action);
    }
  }
  
  return appReducer(state, action);
};

export default rootReducer;
